import ROUTES from '../routes';
import Corporate from '../hoc/corporate/corporate';
import CorporateList from '../hoc/corporate/list';
import CreateCorporateCustomer from '../hoc/corporate/create';
import CorporateCustomerInformation from '../hoc/corporate/information';
import CorporateCustomerOverview from '../hoc/corporate/overview/overview';
import CustomerStatementsTransactions from '../hoc/customers/statements/statements-transactions';
import CustomerStatementsCards from '../hoc/customers/statements/statemenets-cards';
import CorporateCustomerCompanyOfficial from '../hoc/corporate/overview/overview-company-official';
import ProblemGLTransaction from '../hoc/customers/problem-transactions/problem-gl-transaction';
import AmlStatementsTransactions from '../hoc/customers/aml-statements/aml-statements-transactions';
import ProblemInternalTransaction from '../hoc/customers/problem-transactions/problem-internal-transaction';
import ProblemInternalGeneralContent from '../hoc/customers/problem-transactions/problem-internal-general';
import ProblemInternalAmlContent from '../hoc/customers/problem-transactions/problem-internal-aml';
import ProblemInternalLogContent from '../hoc/customers/problem-transactions/problem-internal-log';
import ProblemInternalDocumentsContent from '../hoc/customers/problem-transactions/problem-internal-transaction-documents';
import ProblemInternalChatsContent from '../hoc/customers/problem-transactions/problem-internal-transaction-chats';
import ProblemIncomingTransaction from '../hoc/customers/problem-transactions/problem-incoming-transaction';
import ProblemIncomingGeneralContent from '../hoc/customers/problem-transactions/problem-incoming-general';
import ProblemIncomingOrderContent from '../hoc/customers/problem-transactions/problem-incoming-order';
import ProblemIncomingAmlContent from '../hoc/customers/problem-transactions/problem-incoming-aml';
import ProblemIncomingLogContent from '../hoc/customers/problem-transactions/problem-incoming-log';
import ProblemIncomingChangeLogContent from '../hoc/customers/problem-transactions/problem-incoming-change-log';
import ProblemIncomingDocumentsContent from '../hoc/customers/problem-transactions/problem-incoming-transaction-documents';
import ProblemIncomingChatsContent from '../hoc/customers/problem-transactions/problem-incoming-transaction-chats';
import ProblemOutgoingTransaction from '../hoc/customers/problem-transactions/problem-outgoing-transaction';
import ProblemOutgoingGeneralContent from '../hoc/customers/problem-transactions/problem-outgoing-general';
import ProblemOutgoingOrderContent from '../hoc/customers/problem-transactions/problem-outgoing-order';
import ProblemOutgoingAmlContent from '../hoc/customers/problem-transactions/problem-outgoing-aml';
import ProblemOutgoingLogContent from '../hoc/customers/problem-transactions/problem-outgoing-log';
import ProblemOutgoingChangeLogContent from '../hoc/customers/problem-transactions/problem-outgoing-change-log';
import ProblemOutgoingDocumentsContent from '../hoc/customers/problem-transactions/problem-outgoing-transaction-documents';
import ProblemOutgoingChatsContent from '../hoc/customers/problem-transactions/problem-outgoing-transaction-chats';
import ProblemExchangeTransaction from '../hoc/customers/problem-transactions/problem-exchange-transaction';
import ProblemExchangeGeneralContent from '../hoc/customers/problem-transactions/problem-exchange-transaction-general';
import ProblemExchangeChats from '../hoc/customers/problem-transactions/problem-exchange-transaction-chats';
import ProblemExchangeLog from '../hoc/customers/problem-transactions/problem-exchange-transaction-log';
import ProblemExchangeChangeLog from '../hoc/customers/problem-transactions/problem-exchange-transaction-change-log';
import ProblemNostroTransaction from '../hoc/customers/problem-transactions/problem-nostro-transaction';
import ProblemNostroGeneralContent from '../hoc/customers/problem-transactions/problem-nostro-transaction-general';
import ProblemNostroLog from '../hoc/customers/problem-transactions/problem-nostro-transaction-log';
import ProblemNostroChangeLog from '../hoc/customers/problem-transactions/problem-nostro-transaction-change-log';
import CorporateCustomerAccounts from '../hoc/corporate/accounts/accounts';
import CustomerAccountsTransactions from '../hoc/customers/accounts-statement/account-transactions';
import CustomerAccountsCardsTransactions from '../hoc/customers/accounts-statement/account-cards';
import CardTransaction from '../hoc/customers/accounts-statement/card-transaction';
import CorporateAml from '../hoc/corporate/aml/aml';
import CustomerStatistic from '../hoc/customers/statistic/statistic';
import CorporateCustomerCards from '../hoc/corporate/cards/cards';
import CustomerDocuments from '../hoc/customers/documents/general';
import CustomerDocumentCreate from '../hoc/customers/documents/create';
import CustomerDocumentInfo from '../hoc/customers/documents/info';
import CustomerTariffs from '../hoc/customers/tariffs/tariffs';
import CustomerCreateFee from '../hoc/customers/tariffs/fee-form';
import CustomerTransactionFromFee from '../hoc/customers/tariffs/transaction-from-fee';
import SelectCompanyOfficial from '../hoc/corporate/overview/select-company-official';
import CreateCompanyOfficial from '../hoc/corporate/overview/create-company-official';
import CustomerOrderCard from '../hoc/corporate/cards/order';
import IncomingTransactionWarnings from '../hoc/customers/problem-transactions/problem-incoming-transaction-warnings';
import OutgoingTransactionWarnings from '../hoc/customers/problem-transactions/problem-outgoing-transaction-warnings';
import InternalTransactionWarnings from '../hoc/customers/problem-transactions/problem-internal-transaction-warnings';
import InternalTransactionChangeLogs from '../hoc/customers/problem-transactions/problem-internal-transactions-change-log';
import StatementGLTransaction from '../hoc/customers/statements/transactions/gl';
import CustomerAgreement from '../hoc/customers/documents/agreement-sidepanel';
import Beneficiaries from '../hoc/customers/beneficiaries/beneficiaries';
import Beneficiary from '../hoc/customers/beneficiaries/beneficiary';
import BeneficiaryContract from '../hoc/customers/beneficiaries/beneficiary-contract';
import ExternalAccounts from '../hoc/customers/external/external';
import CreateCustomersExternalAccount from '../hoc/customers/external/create';
import ExternalAccountForm from '../hoc/customers/external/item';
import ExhcangeTransactionComments from '../hoc/customers/problem-transactions/problem-exchange-transaction-comments';
import NostroTransactionComments from '../hoc/customers/problem-transactions/problem-nostro-transcation-comments';
import InternalTransactionComments from '../hoc/customers/problem-transactions/problem-internal-transaction-comments';
import IncomingTransactionComments from '../hoc/customers/problem-transactions/problem-incoming-transaction-comments';
import OutgoingTransactionComments from '../hoc/customers/problem-transactions/problem-outgoing-transacation-comments';
import CustomerExternalAccounts from '../hoc/customers/external/accounts';

import { CustomerType, OrganizationType } from '../hoc/customers/types';
import CustomerLinkedClients from '../hoc/customers/external/linked-clients';
import LinkCustomerForm from '../hoc/customers/external/link-customer';

const CorporateCustomers = {
  path: ROUTES.CUSTOMERS_CORPORATE,
  element: <Corporate />,
  children: [
    {
      path: ROUTES.CUSTOMERS_CORPORATE_LIST,
      element: <CorporateList />,
      children: [
        {
          path: ROUTES.CUSTOMERS_CORPORATE_CREATE,
          element: <CreateCorporateCustomer />,
        },
      ],
    },
    {
      path: ROUTES.CUSTOMERS_CORPORATE_PAGE,
      element: <CorporateCustomerInformation />,
      children: [
        {
          path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW,
          element: <CorporateCustomerOverview />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_TRANSACTIONS,
              element: (
                <CustomerStatementsTransactions
                  customerType={CustomerType.CORPORATE}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_COMPANY_OFFICIAL,
                  element: <CorporateCustomerCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_SELECT_COMPANY_OFFICIAL,
                  element: <SelectCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_ADD_COMPANY_OFFICIAL,
                  element: <CreateCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_TRANSACTIONS_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={CustomerType.CORPORATE}
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={CustomerType.CORPORATE}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_COMPANY_OFFICIAL,
                  element: <CorporateCustomerCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_SELECT_COMPANY_OFFICIAL,
                  element: <SelectCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_ADD_COMPANY_OFFICIAL,
                  element: <CreateCompanyOfficial />,
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS,
          element: <CorporateCustomerAccounts />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_TRANSACTIONS,
              element: (
                <CustomerAccountsTransactions
                  customerType={CustomerType.CORPORATE}
                  accountsPage
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_TRANSACTION_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={CustomerType.CORPORATE}
                      accountsPage
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_CARDS,
              element: (
                <CustomerAccountsCardsTransactions
                  customerType={CustomerType.CORPORATE}
                  page="accounts"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS,
          element: <ExternalAccounts type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS_LIST,
              element: (
                <CustomerExternalAccounts type={OrganizationType.CORPORATE} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS_CREATE,
                  element: (
                    <CreateCustomersExternalAccount
                      type={OrganizationType.CORPORATE}
                    />
                  ),
                },

                {
                  path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS_ITEM,
                  element: (
                    <ExternalAccountForm type={CustomerType.CORPORATE} />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_LINKED_CLIENTS,
              element: (
                <CustomerLinkedClients type={OrganizationType.CORPORATE} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_LINKED_CLIENTS_CREATE,
                  element: (
                    <LinkCustomerForm type={OrganizationType.CORPORATE} />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_AML,
          element: <CorporateAml />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS,
              element: (
                <AmlStatementsTransactions
                  customerType={CustomerType.CORPORATE}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_GL,
                  element: (
                    <ProblemGLTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                    />
                  ),
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE,
                  element: (
                    <ProblemExchangeTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHANGE_LOG
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHATS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE,
                      element: <ProblemExchangeGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_LOG,
                      element: <ProblemExchangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHANGE_LOG,
                      element: <ProblemExchangeChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHATS,
                      element: <ProblemExchangeChats />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_COMMENTS,
                      element: <ExhcangeTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO,
                  element: (
                    <ProblemNostroTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_CHANGE_LOG
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO,
                      element: <ProblemNostroGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_LOG,
                      element: <ProblemNostroLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_CHANGE_LOG,
                      element: <ProblemNostroChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_COMMENTS,
                      element: <NostroTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL,
                  element: (
                    <ProblemInternalTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_WARNING
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_AML
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHANGE_LOG
                      }
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_DOCUMENTS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_GENERAL,
                      element: <ProblemInternalGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_AML,
                      element: <ProblemInternalAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_LOG,
                      element: <ProblemInternalLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_WARNING,
                      element: <InternalTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHANGE_LOG,
                      element: <InternalTransactionChangeLogs />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_DOCUMENTS,
                      element: <ProblemInternalDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHATS,
                      element: <ProblemInternalChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_COMMENTS,
                      element: <InternalTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING,
                  element: (
                    <ProblemIncomingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING
                      }
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHANGE_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_WARNINGS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_DOCUMENTS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_GENERAL,
                      element: <ProblemIncomingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_ORDER,
                      element: <ProblemIncomingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_AML,
                      element: <ProblemIncomingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_LOG,
                      element: <ProblemIncomingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHANGE_LOG,
                      element: <ProblemIncomingChangeLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_WARNINGS,
                      element: <IncomingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_DOCUMENTS,
                      element: <ProblemIncomingDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHATS,
                      element: <ProblemIncomingChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_COMMENTS,
                      element: <IncomingTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING,
                  element: (
                    <ProblemOutgoingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING
                      }
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHANGE_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_WARNINGS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_DOCUMENTS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_GENERAL,
                      element: <ProblemOutgoingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_ORDER,
                      element: <ProblemOutgoingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_AML,
                      element: <ProblemOutgoingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_LOG,
                      element: <ProblemOutgoingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_CHANGE_LOG,
                      element: <ProblemOutgoingChangeLogContent />,
                    },

                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_WARNINGS,
                      element: <OutgoingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_DOCUMENTS,
                      element: <ProblemOutgoingDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_CHATS,
                      element: <ProblemOutgoingChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_COMMENTS,
                      element: <OutgoingTransactionComments />,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_AML_CARDS,
              element: (
                <CustomerAccountsCardsTransactions
                  customerType={CustomerType.CORPORATE}
                  page="aml"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_STATISTICS,
          element: <CustomerStatistic customerType={CustomerType.CORPORATE} />,
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_DOCUMENTS,
          element: <CustomerDocuments customerType={CustomerType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_AGREEMENT,
              element: (
                <CustomerAgreement customerType={CustomerType.CORPORATE} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_DOCUMENTS_INFO,
              element: (
                <CustomerDocumentInfo customerType={CustomerType.CORPORATE} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_DOCUMENTS_ADD,
              element: (
                <CustomerDocumentCreate customerType={CustomerType.CORPORATE} />
              ),
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_CARDS,
          element: <CorporateCustomerCards />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_CARDS_TRANSACTION,
              element: (
                <CardTransaction backPath={ROUTES.CUSTOMERS_CORPORATE_CARDS} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_CARDS_ORDER,
              element: <CustomerOrderCard />,
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_CARDS_EDIT,
              element: <CustomerOrderCard />,
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_TARIFFS,
          element: <CustomerTariffs customerType={CustomerType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_TARIFFS_FEE,
              element: (
                <CustomerCreateFee customerType={CustomerType.CORPORATE} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_TARIFFS_CREATE_TRANSACTION,
                  element: (
                    <CustomerTransactionFromFee
                      customerType={CustomerType.CORPORATE}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_BENEFICIARIES,
          element: <Beneficiaries type={CustomerType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_BENEFICIARY,
              element: <Beneficiary type={CustomerType.CORPORATE} />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_BENEFICIARY_CONTRACT,
                  element: (
                    <BeneficiaryContract type={CustomerType.CORPORATE} />
                  ),
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default CorporateCustomers;
